module.exports = __webpack_public_path__ + "img/cch5.aa9e127e.jpg";